import { Outlet, createFileRoute } from "@tanstack/react-router";

export const Route = createFileRoute("/_public/coaching-for/$challengeSlug")({
  staticData: { title: "Coaching For" },
  component: () => <Outlet />,
});
